import { Link } from 'react-router-dom';
import { heroStats, heroTicker } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20overlapping%20newspaper%20pages%20and%20paper%20clippings%20with%20a%20megaphone%20shape%2C%20deep%20terracotta%20burnt%20orange%20and%20cream%20palette%2C%20bold%20graphic%20art%2C%20dramatic%20warm%20lighting%2C%20textured%20paper%20grain%2C%20no%20legible%20text%2C%20no%20people&width=1600&height=900&seq=gossip-hero-01&orientation=landscape"
          alt="17吃瓜网投稿入口的抽象报纸剪报背景图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/72 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full min-h-[560px] md:min-h-[680px] flex flex-col justify-center px-4 md:px-8 pt-28 pb-16">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-foreground-950 text-xs md:text-sm font-bold whitespace-nowrap">
            <i className="ri-megaphone-line text-base"></i>
            匿名投稿通道 · 全天开放
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl lg:text-7xl leading-[1.08] text-background-50">
            手上有料想上瓜
            <br />
            直接递到编辑手里
          </h1>

          <p className="mt-6 text-base md:text-lg leading-8 text-background-100/90 max-w-2xl">
            17吃瓜网向所有掌握线索的人开放投稿入口：支持<strong className="font-bold text-background-50">匿名投稿</strong>与
            <strong className="font-bold text-background-50">私信爆料</strong>，
            也可以通过线索征集通道把素材直接送到对应方向的编辑手上。
            你要做的只是把事情说清楚，剩下的核实与成稿交给我们。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill text-lg"></i>
              进入投稿入口
            </Link>
            <Link
              to="#flow"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-background-50/12 text-background-50 text-base font-medium border border-background-50/35 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-route-line text-lg"></i>
              先看投稿流程
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
            {heroStats.map((s) => (
              <div key={s.label} className="flex flex-col gap-1">
                <dt className="text-xs text-background-200/80">{s.label}</dt>
                <dd className="font-heading text-2xl md:text-3xl text-background-50">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative w-full bg-primary-950 py-3 overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[...heroTicker, ...heroTicker].map((t, i) => (
            <span key={`${t}-${i}`} className="flex items-center gap-3 px-6 text-sm text-background-100 whitespace-nowrap">
              <i className="ri-circle-fill text-[6px] text-accent-400"></i>
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}